export const Role = {
  Admin: "ADMINISTRATIF",
  Trainer: "FORMATEUR",
  ExternalTrainer: "INDEPENDANT",
  Commercial: "COMMERCIAL",
  Apprenti: "APPRENTI",
  ExternalApprenti: "EXTAPPRENTI",
  NotFound: "NOTFOUND",
  RH: "RH",
  IT: "IT",
  Compta: "COMPTABLE",
};
